import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { buyerNotifications } from '../data/testimonials';
const MINUTES_AGO = [2, 3, 4, 6, 7, 9, 11, 13];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const timeouts = useRef<number[]>([]);
  useEffect(() => {
    let current = 0;
    const schedule = (delay: number) => {
      const showId = window.setTimeout(() => {
        setIndex(current % buyerNotifications.length);
        setVisible(true);
        const hideId = window.setTimeout(() => {
          setVisible(false);
          current += 1;
          schedule(11000 + Math.random() * 7000);
        }, 5200);
        timeouts.current.push(hideId);
      }, delay);
      timeouts.current.push(showId);
    };
    schedule(6000);
    const ids = timeouts.current;
    return () => ids.forEach(id => window.clearTimeout(id));
  }, []);
  const buyer = buyerNotifications[index];
  const minutes = MINUTES_AGO[index % MINUTES_AGO.length];
  return <AnimatePresence data-id="element-52" data-mp="115uygk99aox6">
      {visible ? <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.98
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed left-3 top-3 z-50 w-[calc(100%-1.5rem)] max-w-[330px] rounded-xl border border-white/10 bg-white p-3 shadow-2xl sm:left-4 sm:top-auto sm:bottom-24 sm:w-auto" role="status" aria-live="polite" data-id="element-53" data-mp="1151xjzwzatmy">
          <div className="flex items-start gap-3" data-id="element-54" data-mp="x38000i2y5r0">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-navy-900" data-id="element-55" data-mp="s56hbgokg8g2">
              <CheckCircle2Icon className="h-5 w-5 text-gold-500" aria-hidden="true" data-id="element-56" data-mp="28jeu4jjjb3ei" />
            </div>
            <div className="min-w-0" data-id="element-57" data-mp="23nps89k1laf1">
              <p className="text-[13px] font-bold leading-snug text-navy-950" data-id="element-58" data-mp="2apctz6lmvdl3">
                {buyer.name} from {buyer.country}
              </p>
              <p className="text-[12px] leading-snug text-navy-800/80" data-id="element-59" data-mp="2fpr02j3ocdgh">
                just purchased Technical System PRO 360™
              </p>
              <p className="mt-0.5 text-[11px] font-semibold uppercase tracking-wide text-gold-600" data-id="element-60" data-mp="2pm3ujj71mvca">
                {minutes} minutes ago · verified purchase
              </p>
            </div>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}